import { IInventoryCheckLine } from 'features/inventory/inventory-check/types';
import { BaseService } from 'shared/services/BaseService';

class InventoryCheckLineService extends BaseService<IInventoryCheckLine> {
  constructor() {
    super('inventory-check-lines');
  }
}

export const inventoryCheckLineService = new InventoryCheckLineService();
